import React, { Component, Fragment } from 'react';
//import AutoBind from 'react-autobind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons';
import {Link} from 'react-router-dom';



const BotonBK = ({ name, clase, evento, leyenda, iclase, indice, tooltip }) => {
    const _clase = (tooltip !== undefined) ? (tooltip.length !== 0) ? "tooltiptext2" : "" : "";

    return (
        <div key={indice} className="tooltip2"><span className={_clase}>{tooltip}</span>
            <a key={indice} id={name} href="#" type="button" className={clase} onClick={evento}><i className={iclase}></i>{leyenda}</a>
        </div>
        //<a href="Nuevo-ingresoDeduccion.html" type="button" class="btn btn-sm pull-right flipInX animated"><i class="fa fa-plus"></i></a>    
        
    )
}

const Boton = ({ name, clase, evento, leyenda, iclase, indice, tooltip }) => {
    const _clase = (tooltip !== undefined) ? (tooltip.length !== 0) ? "tooltiptext2" : "" : "";

    return (
        <div key={indice} className="tooltip2"><span className={_clase}>{tooltip}</span>            
            <Link to= {"#"} value={""} name="botonera" id="filtro" type="button"  className={clase} onClick={evento} ><FontAwesomeIcon icon={iclase}/>{leyenda} </Link> 
        </div>
        //<a href="Nuevo-ingresoDeduccion.html" type="button" class="btn btn-sm pull-right flipInX animated"><i class="fa fa-plus"></i></a>    
        //<a key={indice} id={name} href="#" type="button" className={clase} onClick={evento}><FontAwesomeIcon icon={iclase}/>{leyenda}</a>
    )
}

//<button id="btnVerArbol" type="button" className="btn pull-right flipInX animated" onClick={this.onClickVerArbol}><FontAwesomeIcon icon={faAngleDoubleLeft} style={iClase} /></button>


const SelectBotones = ({ botones }) => {

    return botones.map((item, index) => {
        //const _clase =   (item.tooltip !== undefined) ? (item.tooltip.length  !== 0  ) ? "tooltiptext2" : "" : "";  
        return <Boton key={index}
            name={item.name}
            clase={item.clase}
            evento={item.evento}
            leyenda={item.leyenda}
            iclase={item.iclase}
            indice={index}
            tooltip={item.tooltip}
        />
    })
}

class HeaderBotones extends Component {
    constructor(props) {
        super(props)
        //AutoBind(this);
    }
    render() {
        const { botones } = this.props;

        return (
            <Fragment>

                <SelectBotones
                    botones={botones}
                />
            </Fragment>
        );
    }
};
export default HeaderBotones;